import { __assign } from "tslib";
import React from 'react';
import { getDeviationType } from '../_helpers';
import { DeviationTypes } from '../../types/deviation';
import LiteratureContent from './Literature';
import JournalContent from './Journal';
import TierContent from './Tier';
var TextualContent = function (props) {
    var deviationType = getDeviationType(props.deviation);
    switch (deviationType) {
        case DeviationTypes.LITERATURE:
            return React.createElement(LiteratureContent, __assign({}, props));
        case DeviationTypes.JOURNAL:
            return React.createElement(JournalContent, __assign({}, props));
        case DeviationTypes.TIER:
            return React.createElement(TierContent, __assign({}, props));
        default:
    }
    return null;
};
TextualContent.displayName = 'TextualContent';
export default TextualContent;
//# sourceMappingURL=TextualContent.js.map